import Layers from "slotworks/graphics/layers/layers";
import AbstractSliderControl from "slotworks/smart-ui/controls/abstract/abstract-slider-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { formatMoneyAsCurrency } from "slotworks/utils/string-formatters";

export default class SingleWinLossLimitSliderControl extends AbstractSliderControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.formatFunction = formatMoneyAsCurrency;

        this.sliderComponent.onChange.add(this.onChangeHandler);
        this.sliderComponent.onInput.add(this.onChangeHandler);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        if(!options.singleWinLimit.values.length) {
            this.setVisibleSingleWinLossLimit(false);
        }

        if (options.singleWinLimit.values.length > 0 &&
            options.singleWinLimit.values[0] !== 0) {
                options.singleWinLimit.values.unshift(0);
        }
        this.setupData(options.singleWinLimit.values, options.singleWinLimit.currentValue);
    }

    protected onChangeHandler = (value: number) => {
        const options = new ControlOptions();
        options.singleWinLimit = this.options.singleWinLimit.clone();
        options.singleWinLimit.setCurrentIndex(value);

        this.setValueLabel(options.singleWinLimit.currentValue);

        this.onChange.dispatch(options);
    }

    private setVisibleSingleWinLossLimit(visible: boolean) {
        this.setVisible(visible);
        this.setVisibleValue(visible);
    }
}
